import { Spin } from 'antd'
import fileDownload from 'js-file-download'
import React, { useCallback, useEffect, useState } from 'react'
import Gallery from 'react-grid-gallery'
import { useLocation } from 'react-router-dom'
import HTML from '../../components/HTML'
import useActionLog from '../../hooks/useActionLog'
import UserPhotoApi from '../../services/api/UserPhoto.api'

const Photos = () => {
  const location = useLocation()

  const [show, setShow] = useState(false)
  const [pageSize, setPageSize] = useState(50)
  const [pageCurrent, setPageCurrent] = useState(0)
  const [currentIndex, setCurrentIndex] = useState(null)
  const [photos, setPhotos] = useState([])
  const [loading, setLoading] = useState(true)

  const { addLog } = useActionLog({ actionId: 4 })

  const fetchPhotos = useCallback(() => {
    const search = new URLSearchParams(location.search)
    const badge = search.get('badge')
    new UserPhotoApi().findAll({ badge, pageSize, pageCurrent }).then(p => {
      setLoading(false)
      setPhotos(pp => [...pp, ...p])
      if (p?.length > 0) {
        setShow(true)
      }
    })
  }, [location, pageCurrent, pageSize])

  const handleScroll = useCallback(() => {
    const element = document.getElementById('bottom')
    if (element && show) {
      const rect = element.getBoundingClientRect()
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0
      if (isVisible) {
        setShow(false)
        setPageCurrent(p => p + 1)
      }
    }
  }, [show])

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  useEffect(() => {
    fetchPhotos()
  }, [fetchPhotos])

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Spin />
      </div>
    )
  }

  return (
    <div>
      <HTML name="FO_MEETING_PHOTOS_MESSAGE_TOP" />
      {photos.length > 0 ? (
        <div>
          <Gallery
            images={photos.map(p => ({
              src: p.hdFilter || p.hd,
              thumbnail: p.xsFilter || p.xs,
              thumbnailHeight: p.thumbnailHeight,
              thumbnailWidth: p.thumbnailWidth,
            }))}
            enableImageSelection={false}
            backdropClosesModal
            currentImageWillChange={setCurrentIndex}
            customControls={
              currentIndex !== null
                ? [
                    <button
                      className="button is-primary"
                      onClick={async () => {
                        const photo = photos[currentIndex]
                        const url = photo.originalFilter || photo.original
                        const response = await fetch(url, {
                          cache: 'no-cache',
                        })
                        addLog({ actionId: 5, extended: { label: `photo_${photos[currentIndex].id}.jpg` } })
                        fileDownload(await response.blob(), `photo_${photos[currentIndex].id}.jpg`)
                      }}
                    >
                      Télécharger cette photo
                    </button>,
                  ]
                : []
            }
          />
          <div id="bottom" style={{ textAlign: 'center' }}>
            ----
          </div>
        </div>
      ) : (
        <div>
          <HTML name="FO_MEETING_PHOTOS_EMPTY" />
        </div>
      )}
    </div>
  )
}

export default Photos
